import { ApplicationError } from '@msdk/forms'
import { styled } from '@msdk/ui'

const Wrapper = styled('div')`
  display: flex;
  width: 100vw;
  height: 100vh;
`

const BodyWrapper = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 500px;
  margin: auto;
  padding: 1rem;
  gap: 5vh;
`

export function SigninError() {
  return (
    <Wrapper>
      <BodyWrapper>
        <ApplicationError type="BadRequest" />
      </BodyWrapper>
    </Wrapper>
  )
}
